

import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';

/**
 * 「その他」ページ選択コンポーネント
 */
export default {
    name: 'ModalOthersPageSelecter',
    template: '#modal-others-page-selecter-template',
    computed: {
        shop_id: function () {
            return this.config.user.shop_id;
        }
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    emits: ['selected-page'],
    methods: {
        // モーダルを開く
        openModal: function () {
            this.open();
        },
        // ページ選択時処理
        selectePage: function (Url) {
            this.emitSelectedPage(Url);
            this.close();
        },
        // 選択されたページを親に通知する
        emitSelectedPage: function (Url) {
            this.$emit('selected-page', Url);
        }
    },
};
